// @ts-nocheck

import { selectKLUserPoleTotalTime } from '../user';

const { createSelector } = require('reselect');

const selectKLPoleTimerProps = createSelector([selectKLUserPoleTotalTime], (time) => ({
  time,
}));

export default selectKLPoleTimerProps;
